import React from 'react';
import { Box, BoxProps } from '../../CommonComponents/OPL/Box/Box';
import Logo from './logo.svg';
import LogoText from './logo-text.svg';

export const PulseCheckVerticalLogo = (props: BoxProps) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" aria-hidden {...props}>
      <Logo width={72} height={72} />
      <LogoText width={118} height={16} />
    </Box>
  );
};
